module.exports = __webpack_public_path__ + "static/media/tissues.436cca18.svg";